import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface DeleteConfirmCSSStyle extends UIComponentCSSStyle
{
    getHeaderDivCSSStyle():object;
    getTitleCSSStyle():object;
    getMobileTitleCSSStyle():object;
    getCloseIconDivCSSStyle():object;
    getMobileCloseIconDivCSSStyle():object;
    getCloseIconCSSStyle():object;
    getConfirmButtonCSSStyle(): object;
}

export class DeleteConfirmCSSStyleImpl extends UIComponentCSSStyleImpl implements DeleteConfirmCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "308px",
            width: "100%",
            borderRadius: "8px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
        };
    }
    getConfirmButtonCSSStyle(): object 
    {
        return {
            marginTop: "0px",
            width:'225px',
            height: "40px",
            marginLeft: "40px",
        };
    }
    getHeaderDivCSSStyle(): object 
    {
        return {
            backgroundColor: this.getResources().getColor(Colors.color_18),
            width: "100%",
            height: "60px",
            display: "flex",
            flexFlow: "row wrap",
            
            borderRadius: "8px 8px 0px 0px",
        };
    }

    getTitleCSSStyle(): object {
        return {
            // width: "480px",
            height: "40px",
            fontWeight: "900",
            letterSpacing: 0,
            // paddingLeft: "40px",
            // paddingRight: "0px",
            fontSize: this.getResources().getFont(Fonts.h12),
            color:"#000000",
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "left",
            // marginLeft:"5px"
        };
    }
    
    getCloseIconDivCSSStyle(): object 
    {
        return {
            height: "60px",
            width: "60px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }

    getCloseIconCSSStyle(): object 
    {
        return {
            height: "32px",
            width: "32px",
            marginTop: "12px",
            cursor: "pointer",
        };
    }


    getMobileTitleCSSStyle(): object {
        return {
            // width: "97%",
            height: "40px",
            fontWeight: "900",
            letterSpacing: 0,
            // paddingLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "40px" : "0px",
            // paddingRight: "0px",
            fontSize: "18px",
            color:"#000000",
            lineHeight: "40px",
            marginTop: "7px",
            textAlign: "left",
            // marginLeft:"5px"
        };
    }
    
    getMobileCloseIconDivCSSStyle(): object 
    {
        return {
            height: "40px",
            width: "40px",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
            display: "inline-block",
            cursor: "pointer"
        };
    }
}    
   


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/deleteconfirmation/deleteconfirmationcss.tsx